
const dialogs = {
  // Dialog Translations
  loginDialog: {
    title: "Welcome Back",
    description: "Sign in to your account to access AI-powered predictions and analytics.",
    loginButton: "Sign In",
    forgotPassword: "Forgot your password?",
    noAccount: "Don't have an account?",
    registerNow: "Register now"
  },

  registerDialog: {
    title: "Create Account",
    description: "Join thousands of users already using our AI predictions to improve their betting results.",
    registerButton: "Create Account",
    hasAccount: "Already have an account?",
    loginNow: "Sign in now"
  },

  recoveryDialog: {
    title: "Password Recovery",
    description: "Enter your email address and we'll send you a link to reset your password.",
    resetButton: "Send Reset Link",
    backToLogin: "Back to Login"
  }
};

export default dialogs;
